<template>
  <div class="ion-page">
    <ion-header>
      <ion-toolbar>
        <ion-title>Add Family Account</ion-title>
        <ion-buttons slot="start">
          <ion-back-button href="/"></ion-back-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>
    <ion-content>
      <ion-spinner
        class="spinner"
        v-if="showSpinner"
        name="bubbles"
      ></ion-spinner>
      <br />
      <br />
      <ion-grid>
        <ion-row justify-content-center>
          <ion-col align-self-center size-md="6" size-lg="5" size-xs="12">
            <div padding>
              <ion-item>
                <ion-input
                  type="text"
                  :value="userName"
                  ref="theUserName"
                  name="userName"
                  placeholder="Username"
                ></ion-input>
              </ion-item>
              <ion-item>
                <ion-input
                  type="password"
                  :value="userPassword"
                  ref="theUserPassword"
                  name="userPassword"
                  placeholder="Password"
                ></ion-input>
              </ion-item>
            </div>
            <div>
              <ion-button
                size="default"
                class="adjust-font-size"
                @click="addFamilyAccount"
                expand="block"
                >Add Account</ion-button
              >
            </div>
            <div>
              <ion-item>
                <ion-label class="family-account adjust-font-size"
                  >Please Provide Id and Password</ion-label
                >
              </ion-item>
              <ion-item>
                <ion-label class="family-account adjust-font-size"
                  >of Account To Add</ion-label
                >
              </ion-item>
            </div>
          </ion-col>
        </ion-row>
      </ion-grid>
    </ion-content>
  </div>
</template>
<script>
import Repository from "../../repositories/RepositoryFactory";
var  AuthorizationRepository = Repository.get("authorization");
var  FamilyAccountRepository = Repository.get("familyaccount");
export default {
  data() {
    return {
      info: null,
      userName: "",
      userPassword: "",
      showSpinner: false,
    };
  },
  methods: {
    returnTomainMenu() {
      let self = this;
      self.$router.push({ name: "main" });
    },
    addFamilyAccount: async function () {
      let self = this;

      this.showSpinner = true;

      this.userName = this.$refs.theUserName.value;
      this.userPassword = this.$refs.theUserPassword.value;
      var userLogin = {
        UserName: this.userName,
        Password: this.userPassword,
      };

      var  result = await AuthorizationRepository.login(userLogin);
      if (result.data.status === "Success") {
        // eslint-disable-next-line no-console
        console.log(result);
        var userIdInteger = parseInt(this.$store.state.userId, 10);
        var newFamilyAccount = {
          MainAccount: userIdInteger,
          AddedAccount: result.data.userId,
        };

        var  addFamilyAccountResult = await FamilyAccountRepository.createFamilyAccount(
          newFamilyAccount
        );

        if (addFamilyAccountResult.data.status === "Success") {
          this.showSpinner = false;
          alert("Family Account added Successfully");
          // eslint-disable-next-line no-console
          console.log(result);
          self.$router.push({ name: "main" });
        } else {
          this.showSpinner = false;
          alert(addFamilyAccountResult.data.status);
          self.$router.push({ name: "main" });
        }
        // eslint-disable-next-line no-console
      } else {
        this.showSpinner = false;
        alert("Id or Password not Correct. " + result.data.status);
      }
    },
  },
};
</script>
